import { render } from "./EvolPnlComparisonChart.vue?vue&type=template&id=f1815de2"
import script from "./EvolPnlComparisonChart.vue?vue&type=script&lang=js"
export * from "./EvolPnlComparisonChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__